<template>
  <section id="community-section" class="common-padding mb-20">
    <div class="flex flex-col">
      <h3
        id="communityTitle"
        v-html="extracurricularTitle"
        class="heading-1 text-start leading-none font-bold uppercase whitespace-pre-line sm:whitespace-normal"
      ></h3>
      <p
        class="heading-1 text-flax-smoke-400 text-opacity-50 hidden w-4/5 text-end font-extrabold sm:block"
      >
        <!-- Removed the counter -->
      </p>

      <div
        id="community-text"
        class="md:column-gap text-flax-smoke-300 mt-[5%] grid grid-cols-12 justify-end opacity-0 lg:grid"
      >
        <p
          class="heading-6 text-flax-smoke-300/85 col-span-4 text-center text-nowrap lg:col-start-2"
        >
          ( OUTREACH )
        </p>
        <p
          class="heading-4 font-fancy col-span-8 w-full text-balance sm:font-semibold lg:col-span-7"
        >
          Leadership roles, engineering design teams, and community involvement in tech education and youth development.
        </p>
      </div>
    </div>

    <div class="mt-12 lg:mt-[10%]">
      <div
        v-for="(activity, index) in extracurricularData"
        :key="index"
        class="extracurricular-card border-b border-flax-smoke-500/40 py-5 last:border-b-0"
      >
        <div class="flex flex-col sm:flex-row sm:items-center gap-y-0.5 gap-x-5">
          <span class="font-title! font-bold uppercase tracking-wide text-flax-smoke-100 text-lg sm:text-xl shrink-0">
            {{ activity.organization }}
          </span>
          <span class="text-flax-smoke-300 text-base sm:text-lg flex-1 min-w-0">
            {{ activity.position }}
          </span>
        </div>
        <ul class="mt-3 space-y-2">
          <li
            v-for="(achievement, achievementIndex) in activity.achievements"
            :key="achievementIndex"
            class="text-flax-smoke-400/80 text-sm leading-relaxed"
          >
            <span class="text-flax-smoke-500">•</span> {{ achievement }}
          </li>
        </ul>
      </div>
    </div>

  </section>
</template>

<script setup lang="ts">
  import { animateSplitText } from '@/animations';
  import { onBeforeMount, onMounted, ref } from 'vue';
  const extracurricularTitle = ref('Extracurricular /');

  const extracurricularData = [
  // {
  //     position: 'Flight Computer Software Member',
  //     organization: 'Arbalest Rocketry',
  //     achievements: [
  //            ]
  //   },

  {
    position: 'Tech Lead',
    organization: 'Google Developer Group (GDG) on Campus @ York University',
    achievements: [
      'Scale the club to 200+ members with the founding team by shipping hands-on technical workshops and case competitions, growing an inclusive developer community on campus from the ground up.',
      'Architect and drive the technical vision for all club initiatives, overseeing the design, development, and deployment of scalable systems for workshops and internal projects.',
      'Recruit, lead, and mentor a team of student developers, ensuring adherence to software development best practices, clean code, and efficient system architecture, while collaborating with leadership to align technical efforts with the organization\'s strategic goals.'
    ]
  },
  {
    position: 'Rover Software Member',
    organization: 'York University Robotics Society',
    achievements: [
      'Build a (hopefully) autonomous rover.'
    ]
  },
  {
    position: 'Electrical & Vehicle Dynamics Member',
    organization: 'York Univeristy Baja SAE Design Team',
    achievements: [
      'Design and build an off-road vehicle.'
    ]
  },
  {
    position: 'Imaging & Flight Computer Software Member',
    organization: 'Arbalest Rocketry',
    achievements: [
      'Contribute to the Flight Computer Software & Imaging Team. Develop a YOLOv8n computer vision model on NVIDIA Jetson, integrating with a motorized mount for real-time rocket tracking; co-build flight computer software to integrate temperature sensor data for in-flight telemetry.'
    ]
  },
  {
    position: 'Vice President of AI/ML & Research',
    organization: 'AI/ML For Impact @ York University',
    achievements: [
      'Oversaw the AI/ML & Researchers Team; led the design, implementation, and research of AI/ML projects addressing healthcare, social, and humanitarian issues, contributing to academic conference submissions and advancing ethical AI for impact.',
      'Collaborated with cross-functional teams to analyze data, document findings, and develop educational materials and workshops to make AI concepts accessible to high school and community audiences.'
    ]
  },
    {
      position: 'Representative, Outreach Lead',
      organization: 'Women in Computer Science & Engineering @ Lassonde Faculty Committee',
      achievements: [
        'Spearheaded a 10-person team under Lassonde faculty committee to deliver Equity, Diversity, and Inclusion (EDI) and Women in Tech workshops, engaging 160+ STEM students and fostering inclusive tech communities.',
        'Created safe spaces for underrepresented groups in STEM, directly impacting diversity initiatives across campus.'
      ]
    },
    {
      position: 'Fundraising & Coding Mentor',
      organization: 'Girl Up @ Local Chapter (United Nations)',
      achievements: [
        'Delivered programming and IT lessons to 50+ girls from underprivileged backgrounds, while successfully raising funds for tech equipment at an under-resourced middle school in Vietnam.',
        'Empowered young girls with digital literacy skills in an effort to bridge the gender gap in technology education.'
      ]
    },
    {
      position: 'Ambassador',
      organization: 'AIESEC in Vietnam, Global Citizens Project',
      achievements: [
        'Led 50 team members to build a 5-day summer camp agenda for 150 students across Vietnam; prepared lesson plans for 5 workshops on youth leadership, global competence, and social activism with a focus on how to start effective initiatives that tackle educational inequality in the region.',
        'Organized 2 cultural exchange days; facilitated cross-cultural learning experiences and mentored future leaders, creating lasting impact on youth development in Vietnam.'
      ]
    },
    {
      position: 'Organizer',
      organization: 'Hanoi Math Modeling',
      achievements: [
        'Worked with a team of 40 members to organize 3 yearly events, including information sessions, an online math modelling competition, and a nation-wide on-site math modelling competition for over 100 students ages 15-19.',
        'Built a community of young math enthusiasts, fostering critical thinking and problem-solving skills among high school students.'
      ]
    }
  ];

  onBeforeMount(() => {
    extracurricularTitle.value = `Community /`;
  });

  onMounted(() => {
    animateSplitText(
      '#communityTitle .letters',
      '#community-text',
      0.7,
      0.01,
      0,
    );
  });
</script>

<style scoped>
  .extracurricular-card {
    /* Removed @apply directive */
  }
</style>

